"use strict";
"use client";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _getMermaid = require("./getMermaid");
var _MarkdownStreamingContext = require("./MarkdownStreamingContext");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Mermaid = function Mermaid(_ref) {
  var chart = _ref.chart;
  var containerRef = (0, _react.useRef)(null);
  var isStreaming = (0, _MarkdownStreamingContext.useMarkdownStreaming)();
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  (0, _react.useEffect)(function () {
    var container = containerRef.current;
    if (!container) return;
    if (!chart.trim()) {
      container.innerHTML = "";
      setError(null);
      return;
    }
    var cancelled = false;
    var id = "mermaid-".concat(Math.random().toString(36).slice(2));
    (0, _getMermaid.getMermaid)().then(function (mermaid) {
      return mermaid.render(id, chart);
    }).then(function (_ref2) {
      var svg = _ref2.svg;
      if (cancelled) return;
      container.innerHTML = svg;
      var svgEl = container.querySelector("svg");
      if (svgEl) svgEl.style.overflow = "visible";
      setError(null);
    }).catch(function (err) {
      var _err$message;
      if (cancelled || isStreaming) return;
      setError(String((_err$message = err === null || err === void 0 ? void 0 : err.message) !== null && _err$message !== void 0 ? _err$message : err));
    });
    return function () {
      cancelled = true;
    };
  }, [chart, isStreaming]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "my-2",
    "data-sentry-component": "Mermaid",
    "data-sentry-source-file": "Mermaid.tsx",
    children: [error && /*#__PURE__*/(0, _jsxRuntime.jsx)("pre", {
      className: "p-3 rounded-xl my-2 overflow-x-auto bg-background-subtle text-foreground-primary text-sm",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("code", {
        className: "font-mono",
        children: chart
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ref: containerRef,
      className: error ? "hidden" : "overflow-x-auto p-2"
    })]
  });
};
var _default = exports.default = Mermaid;